import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { userKeys } from './user-keys';
import useGetUserAddress from 'src/hooks/useGetUserAddress';
import { Address } from 'viem';

export interface CombineSignaturesData {
  signature: string | undefined;
  signatureID: number;
}

export interface CombineSignaturesResponse {
  id: number;
  signature: string;
  combinedPublicKey: string;
  challenge: string;
  signatureData: string;
  signatureType: 'WITHDRAWAL';
}

export const combineSignatures = async (data: CombineSignaturesData) => {
  const response = await apiClient.post<CombineSignaturesResponse>(
    '/api/v2/signatures/aggregations',
    data,
    {
      baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
    },
  );
  console.log('🚀 ~ combineSignatures ~ response:', response, data);

  return response.data;
};

export type useCombineSignaturesOptions<TError = Error, TContext = unknown> = MutationOptions<
  CombineSignaturesResponse,
  TError,
  CombineSignaturesData,
  TContext
>;

export const useCombineSignatures = <TError = Error, TContext = unknown>(
  options?: useCombineSignaturesOptions<TError, TContext>,
) => {
  const queryClient = useQueryClient();
  const { address: userAddress } = useGetUserAddress();
  return useMutation({
    mutationFn: combineSignatures,
    onSuccess() {
      return queryClient.invalidateQueries({
        queryKey: userKeys.allcombineSignatures(userAddress as Address),
      });
    },
    ...options,
  });
};
